module.exports = __webpack_public_path__ + "static/media/contacts.79f628f7.svg";